import clientConfiguration from "../../client-configuration";
import { BannerDto } from "../../lib-api";

export function createBannerAnchorElement(banner: BannerDto) {
  const anchor = document.createElement("a");
  anchor.className = `b4nn3r w${banner.width}_h${banner.height}`;
  anchor.setAttribute("aria-hidden", "true");
  anchor.title = "Reklame";
  anchor.href = banner.href!;
  anchor.setAttribute(
    "rel",
    `noopener ${banner.hrefDoFollow ? "" : "nofollow"}`
  );
  anchor.target = "_blank";
  anchor.dataset.id = banner.bookingId;
  anchor.dataset.background = banner.imageSrc!;
  anchor.dataset.backgroundretina = banner.imageSrcRetina!;

  return anchor;
}

export function createPlaceholderBannerAnchorElement() {
  const anchor = document.createElement("a");
  anchor.className = `b4nn3r w300_h160 d-flex flex-column justify-content-between py-3`;
  anchor.setAttribute("aria-hidden", "true");
  anchor.title = "Reklame";
  anchor.href = `mailto:${clientConfiguration.bannerPlaceholder.salesEmail}`;
  anchor.setAttribute("rel", "noopener nofollow");
  anchor.target = "_blank";

  const label = document.createElement("strong");
  label.innerText = "Skal din annonce være her?";
  label.className = "text-uppercase";
  anchor.appendChild(label);

  const img = document.createElement("img");
  img.dataset.src = clientConfiguration.bannerPlaceholder.logo;
  anchor.appendChild(img);

  anchor.append("Skriv til os! - salg@voresdigital.dk");

  return anchor;
}
